export const Loader = ({
  size = 'md',
  color = 'blue',
  variant = 'default',
}: {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  color?: string;
  variant?: 'default' | 'checkout';
}) => {
  const sizeClasses = {
    xs: 'w-4 h-4 border-1',
    sm: 'w-6 h-6 border-2',
    md: 'w-10 h-10 border-4',
    lg: 'w-16 h-16 border-[6px]',
  };
  const checkoutSizeClasses = {
    xs: 'w-4 h-4 border-1',
    sm: 'w-6 h-6 border-2',
    md: 'w-10 h-10 border-[3px]',
    lg: 'w-14 h-14 border-[3px]',
  };
  const trackColor = color === 'blue' ? 'rgba(68, 138, 227, 0.14)' : 'transparent';

  return (
    <div data-testid="loader" className="flex items-center justify-center">
      <div
        data-testid="loader-spinner"
        className={`animate-spin rounded-full border-solid border-t-${color} ${
          variant === 'checkout' ? checkoutSizeClasses[size] : sizeClasses[size]
        }`}
        style={{
          borderColor: variant === 'checkout' ? trackColor : 'transparent',
          borderTopColor: `var(--color-${color})`,
        }}
      />
    </div>
  );
};
